import React, {useState, useCallback} from 'react';

import {CardType} from 'desktop/types/creditCardType';

import {PaymentFooter} from '../paymentFooter/paymentFooter';
import {SavedCardsList} from '../savedCardsList/savedCardsList';
import {SavedCardsSwitcherConnected} from '../savedCardsSwitcher/savedCardsSwitcher';

export type PropsType = {
    cards: Array<CardType>;
    isLoading: boolean;
    savePayment: ({
        cvv,
        shouldSave,
        token,
    }: {
        token: string;
        shouldSave: boolean;
        cvv?: string;
    }) => void;
    onSavePayment?: () => void;
};

/**
 * Saved cards select for card payment form
 *
 * @constructor
 */
export const SavedCards: React.FC<PropsType> = ({cards, isLoading, onSavePayment, savePayment}) => {
    const [selectedCard, setSelectedCard] = useState<number>(0);

    /**
     * Save payment method, using previous saved card on checkout
     * and post Post Purchase Insurance page.
     */
    const savePaymentWithSavedCard = useCallback(() => {
        savePayment({shouldSave: false, token: cards[selectedCard].token});

        if (onSavePayment) onSavePayment();
    }, [cards, onSavePayment, savePayment, selectedCard]);

    return (
        <>
            <SavedCardsList
                cards={cards.map(({lastDigits, token}) => ({
                    id: token,
                    name: `XXXX-${lastDigits}`,
                }))}
                onChange={setSelectedCard}
            />
            <SavedCardsSwitcherConnected />
            <PaymentFooter isLoading={isLoading} onSubmit={savePaymentWithSavedCard} />
        </>
    );
};
